import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    receipts: [],
    pagination: {
        currentPage: 1,
        totalPages: 1,
        totalReceipts: 0,
        hasNext: false,
        hasPrev: false,
    },
    lastCreatedReceipt: null,
    savedServices: [],
    loading: false,
    error: null,
    status: "idle",
};

const receiptSlice = createSlice({
    name: "receipt",
    initialState,
    reducers: {
        setReceipts: (state, action) => {
            state.receipts = action.payload.receipts;
            state.pagination = action.payload.pagination;
            state.status = "succeeded";
        },
        setLastCreatedReceipt: (state, action) => {
            state.lastCreatedReceipt = action.payload;
            state.status = "succeeded";
        },
        clearLastCreatedReceipt: (state) => {
            state.lastCreatedReceipt = null;
        },
        setReceiptLoading: (state, action) => {
            state.loading = action.payload;
            state.status = action.payload ? "loading" : "idle";
        },
        setReceiptError: (state, action) => {
            state.error = action.payload;
            state.status = "failed";
        },
        setSavedServices: (state, action) => {
            state.savedServices = action.payload;
        },
    },
});

export const {
    setReceipts,
    setLastCreatedReceipt,
    clearLastCreatedReceipt,
    setReceiptLoading,
    setReceiptError,
    setSavedServices,
} = receiptSlice.actions;

export default receiptSlice.reducer;
